import React from "react";
import SkeletonElement from "./SkeletonElement";

export default function SkeletonCardProfile() {
  return (
    <div className="skeletonWrapper py-[53px] px-12 rounded-2xl  xl:w-[30%] animate-pulse">
      <div className="flex flex-col items-center">
        <SkeletonElement type="avatar" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
        <SkeletonElement type="text" />
      </div>
    </div>
  );
}
